// Generella utilfunktioner för gravplatsvy

// Formatera nummer med 2 decimaler och komma
export const formatDecimal = (value: number | null | undefined): string => {
  if (value === null || value === undefined) {
    return '-';
  }
  return value.toFixed(2).replace('.', ',');
};

// Dölj fält om data saknas
export const shouldShowField = (value: any): boolean => {
  return value != null;
};

// Bara första bokstaven stor
export const formatAllCapsText = (
  status: string | null | undefined
): string => {
  if (!status) return '-';
  return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
};
